import { Box } from '@mui/material'
import { GetStaticProps } from 'next'

import { Faq } from '@ecm/data/Faq'
import { runEff } from '@ecm/effect'
import FaqBlock from '@ecm/ui/component/block/Faq'
import NewsletterSignupCta from '@ecm/ui/component/block/NewsletterSignupCta'
import PlainHeader from '@ecm/ui/component/block/PlainHeader'
import DefaultLayout from '@ecm/ui/layout/Default'
import FaqJsonLd from '@ecm/ui/seo/FaqJsonLd'

type FaqPageProps = {
  allFaqs: Faq[]
  basicFaqs: Faq[]
  billingFaqs: Faq[]
  checkDepositFaqs: Faq[]
  gettingStartedFaqs: Faq[]
  virtualMailFaqs: Faq[]
  securityFaqs: Faq[]
  storageFaqs: Faq[]
}

export const FaqPage = ({
  allFaqs,
  basicFaqs,
  billingFaqs,
  checkDepositFaqs,
  gettingStartedFaqs,
  virtualMailFaqs,
  securityFaqs,
  storageFaqs,
}: FaqPageProps) => (
  <DefaultLayout seoPage="frequently-asked-questions">
    <PlainHeader title="Frequently Asked Questions" />

    <Box sx={{ py: { md: '4em', xs: '2em' } }}>
      <FaqJsonLd faq={allFaqs} />

      <FaqBlock faqs={basicFaqs} heading="General" renderJsonLd={false} />

      <FaqBlock faqs={virtualMailFaqs} heading="Virtual Mail" renderJsonLd={false} />

      <FaqBlock faqs={gettingStartedFaqs} heading="Getting Started" renderJsonLd={false} />

      <FaqBlock faqs={securityFaqs} heading="Security" renderJsonLd={false} />

      <FaqBlock faqs={storageFaqs} heading="Storage/Forwarding" renderJsonLd={false} />

      <FaqBlock faqs={checkDepositFaqs} heading="Check Deposit" renderJsonLd={false} />

      <FaqBlock faqs={billingFaqs} heading="Billing" renderJsonLd={false} />

      <NewsletterSignupCta />
    </Box>
  </DefaultLayout>
)

export default FaqPage

export const getStaticProps: GetStaticProps = async () => {
  const Faqs: Faq[] =
    (await runEff(eff => eff.getFaqsByPage(['/frequently-asked-questions']))) || []

  return {
    props: {
      allFaqs: Faqs,
      basicFaqs: Faqs.filter(f => f.categories.includes('general')),
      billingFaqs: Faqs.filter(f => f.categories.includes('billing')),
      checkDepositFaqs: Faqs.filter(f => f.categories.includes('check-deposit')),
      gettingStartedFaqs: Faqs.filter(f => f.categories.includes('getting-started')),
      securityFaqs: Faqs.filter(f => f.categories.includes('security')),
      storageFaqs: Faqs.filter(f => f.categories.includes('storage/forwarding')),
      virtualMailFaqs: Faqs.filter(f => f.categories.includes('virtual-mail')),
    },
  }
}
